// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.profile.RentalManagerUserProfileWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserProfileWebApiHandler_getNames,
  RentalManagerUserProfileWebApiHandler_getNames_Path,
  RentalManagerUserProfileWebApiHandler_saveUserInfo,
  RentalManagerUserProfileWebApiHandler_setName,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  ProfileType,
  PropertyCountRangeType,
  UserProfileGetNamesRequestWebDto,
  UserProfileGetNamesResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface SaveUserInfoParams {
  firstName?: string;
  /**
   * @deprecated
   */
  isLandlord?: boolean;
  /**
   * @deprecated
   */
  isPropertyManager?: boolean;
  lastName?: string;
  profileType?: ProfileType;
  /**
   * @deprecated
   */
  propertyCount?: number;
  propertyCountRangeType?: PropertyCountRangeType;
}
interface SetNameParams {
  firstName: string;
  lastName: string;
}

export type RentalManagerUserProfileWebApiHandler_getNames_Options = UseQueryOptions<
  UserProfileGetNamesResponseWebDto,
  unknown,
  UserProfileGetNamesResponseWebDto,
  readonly [string, UserProfileGetNamesRequestWebDto]
>;

const RentalManagerUserProfileWebApiHandler_getNames_GetKey = (postData: UserProfileGetNamesRequestWebDto) =>
  [RentalManagerUserProfileWebApiHandler_getNames_Path, postData] as const;

export const RentalManagerUserProfileWebApiHandler_getNames_queryOptions = (
  postData: UserProfileGetNamesRequestWebDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserProfileWebApiHandler_getNames_GetKey(postData),
    queryFn: () => RentalManagerUserProfileWebApiHandler_getNames(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get Zillow user profile names
 */
export const useRentalManagerUserProfileWebApiHandler_getNames = (
  postData: UserProfileGetNamesRequestWebDto,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserProfileWebApiHandler_getNames_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserProfileWebApiHandler_getNames_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useRentalManagerUserProfileWebApiHandler_getNames.getKey = RentalManagerUserProfileWebApiHandler_getNames_GetKey;

export interface RentalManagerUserProfileWebApiHandler_saveUserInfo_Args {
  getParams: SaveUserInfoParams;
}

export type RentalManagerUserProfileWebApiHandler_saveUserInfo_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserProfileWebApiHandler_saveUserInfo_Args
>;

/**
 * Set user info
 */
export const useRentalManagerUserProfileWebApiHandler_saveUserInfo = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserProfileWebApiHandler_saveUserInfo_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserProfileWebApiHandler_saveUserInfo_Args) =>
      RentalManagerUserProfileWebApiHandler_saveUserInfo(args.getParams, httpClient),
  });
};

export interface RentalManagerUserProfileWebApiHandler_setName_Args {
  getParams: SetNameParams;
}

export type RentalManagerUserProfileWebApiHandler_setName_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserProfileWebApiHandler_setName_Args
>;

/**
 * Set user's name
 */
export const useRentalManagerUserProfileWebApiHandler_setName = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserProfileWebApiHandler_setName_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserProfileWebApiHandler_setName_Args) =>
      RentalManagerUserProfileWebApiHandler_setName(args.getParams, httpClient),
  });
};
